module.exports = __webpack_public_path__ + "img/cannula.c770fff4.gif";